<template>

<div class="main terms-of-use">
	<div class="list-view with-sidebar">

    	<div class="filters">
            <div class="button action" @click="agreeToTerms()">I have read and agree to these Terms of Use</div>
            <div class="note-full-width">{{ message }}</div>
        </div>

        <loading v-if="loading"></loading>
        <div v-else style="padding: 0 0 0 1em;">
            <div v-html="content"></div>
        </div>
    </div>
</div>

</template>

<script>
export default {
    name: 'terms-of-use',
    data() {
        return {
            loading: true,
            message: '',
            content: '',
        }
    },
    created() {
        this.getTermsOfUse()
    },
    methods: {
    	getTermsOfUse() {
    		this.apiCall({ destination: 'get_terms_of_use' }).then(obj => {
                this.loading = false
    			if (obj.status == 'success') {
                    this.content = obj.content
    			}
    		})
    	},
        agreeToTerms() {
            this.message = ''
    		this.apiCall({ destination: 'agree_to_terms_of_use' }).then(obj => {
                this.loading = false
                this.message = obj.message
    		})
        }
    }
}
</script>

<style lang="scss" scoped>
@media print {
    .list-view { grid-template-columns: 1fr; }
    .filters { display: none; }
}
</style>
